var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "main_layer py-2", attrs: { fluid: "" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "9" } },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "float-right",
                      attrs: { to: { name: "CabinetFl44RatingHistory" } },
                    },
                    [
                      _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
                        ? _c(
                            "b-badge",
                            {
                              staticClass: "mt-1 fs-18 mr-2",
                              attrs: {
                                variant: "inverse-green",
                                title: "Рейтинг заказчика",
                              },
                            },
                            [
                              _vm._v(" Заказчик "),
                              _c("b-icon-star-fill"),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.state.organization
                                      .customer_rating
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-badge",
                        {
                          staticClass: "mt-1 fs-18",
                          attrs: {
                            variant: "inverse-green",
                            title: "Рейтинг поставщика",
                          },
                        },
                        [
                          _vm._v(" Поставщик "),
                          _c("b-icon-star-fill"),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(
                              _vm._s(_vm.$store.state.organization.rating)
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "fs-36 fw-600 white-color mb-1" }, [
                    _vm._v("Личный кабинет"),
                  ]),
                  _c("p", { staticClass: "fs-14 greyBg-color mb-2" }, [
                    _vm._v(" Наименование организации: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$store.state.organization.short_name)),
                    ]),
                  ]),
                  _c("p", { staticClass: "fs-14 greyBg-color mb-2" }, [
                    _vm._v(" Пользователь: "),
                    _c("strong", [_vm._v(_vm._s(_vm.$store.state.user.name))]),
                    _c("span", { staticClass: "pl-5" }, [
                      _vm._v(" Логин: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$store.state.user.username)),
                      ]),
                    ]),
                  ]),
                  _vm.features.telegram_bot
                    ? _c("p", { staticClass: "fs-14 greyBg-color mb-2" }, [
                        _vm._v(" ID Пользователя для Telegram / MAX: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$store.state.user.id)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44) ||
                  _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL223) ||
                  _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_COMMERCIAL)
                    ? _c(
                        "b-dropdown",
                        {
                          attrs: {
                            variant: "custom-white",
                            text: "Создать закупку",
                          },
                        },
                        [
                          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    to: { name: "Fl44PurchaseCreate" },
                                    "link-class": "grey-color fs-14",
                                  },
                                },
                                [_vm._v("44-ФЗ в ИС (ИМЗ)")]
                              )
                            : _vm._e(),
                          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    to: {
                                      name: "Fl44UnknownVolumePurchaseCreate",
                                    },
                                    "link-class": "grey-color fs-14",
                                  },
                                },
                                [_vm._v("44-ФЗ с неопределенным объемом (НМЗ)")]
                              )
                            : _vm._e(),
                          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    to: {
                                      name: "ExternalPurchaseCreate",
                                      params: { mode: "create" },
                                    },
                                    "link-class": "grey-color fs-14",
                                  },
                                },
                                [_vm._v("44-ФЗ вне ИС (ВМЗ)")]
                              )
                            : _vm._e(),
                          _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL223)
                            ? [
                                _vm.$store.state.organization.settings.fl223
                                  .allowed
                                  ? [
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to: { name: "Fl223PurchaseCreate" },
                                            "link-class": "grey-color fs-14",
                                          },
                                        },
                                        [_vm._v("223-ФЗ")]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            id: "popover-create-fl223",
                                            "link-class": "grey-color fs-14",
                                          },
                                        },
                                        [_vm._v("223-ФЗ")]
                                      ),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "popover-create-fl223",
                                            triggers: "hover",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fs-12" },
                                            [
                                              _vm._v(
                                                " Для создания закупки 223-ФЗ требуется дополнительная информация. Пожалуйста перейдите в "
                                              ),
                                              _c(
                                                "router-link",
                                                {
                                                  staticStyle: {
                                                    color: "var(--green-color)",
                                                    "text-decoration":
                                                      "underline",
                                                  },
                                                  attrs: {
                                                    to: {
                                                      name: "CabinetFl223Settings",
                                                    },
                                                    "active-class": "",
                                                    "exact-active-class": "",
                                                  },
                                                },
                                                [_vm._v("настройки")]
                                              ),
                                              _vm._v(". "),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                          _vm.orgRoleIsPermitted(
                            _vm.$orgRoles.CUSTOMER_COMMERCIAL
                          )
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    to: { name: "CommercialPurchaseCreate" },
                                    "link-class": "grey-color fs-14",
                                  },
                                },
                                [_vm._v("Коммерческая")]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("b-col", { attrs: { md: "3" } }, [
                _c(
                  "div",
                  { staticClass: "text-right mr-2" },
                  [
                    _vm.getCertificateNeedToBeProlonged
                      ? _c(
                          "b-btn",
                          {
                            staticClass: "text-uppercase my-1 mx-2 w-100",
                            attrs: {
                              href: _vm.$links.prolong_certificate,
                              "active-class": "",
                              "exact-active-class": "",
                              target: "_blank",
                              variant: "custom-danger",
                            },
                          },
                          [_vm._v("Продлить ЭЦП ")]
                        )
                      : _vm._e(),
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "text-uppercase my-1 mx-2 w-100",
                        attrs: {
                          variant: "custom-white",
                          text: "Подключить уведомления",
                          right: "",
                        },
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              href: _vm.$links.telegram_events_bot,
                              target: "_blank",
                              "link-class": "grey-color fs-14",
                            },
                          },
                          [
                            _c("svg-icon-tg", { staticClass: "mr-2" }),
                            _vm._v("Telegram"),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              href: _vm.$links.max_events_bot,
                              target: "_blank",
                              "link-class": "grey-color fs-14",
                            },
                          },
                          [
                            _c("svg-icon-max", { staticClass: "mr-2" }),
                            _vm._v("MAX"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm.$store.state.user.need_to_have_poa &&
          _vm.$store.state.user.need_to_upload_poa
            ? _c(
                "b-row",
                { staticClass: "pt-1 text-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "fs-14 font-weight-bold w-100",
                          attrs: {
                            variant: "danger",
                            to: { name: "CabinetUserProfile" },
                          },
                        },
                        [
                          _vm._v(
                            "Необходимо загрузить/заменить МЧД на странице: Данные учетной записи"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.$store.state.organization
            .available_fl44_proposal_submission_status.id === "blocked"
            ? _c(
                "b-row",
                { staticClass: "pt-1 text-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "fs-14 font-weight-bold w-100",
                          attrs: { variant: "danger" },
                        },
                        [
                          _vm._v(
                            "Подача предложений в закупках 44-ФЗ заблокирована до " +
                              _vm._s(
                                _vm.$store.state.organization
                                  .expiration_datetime_blocking_fl44_proposal_submission
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }